/**
 * @generated SignedSource<<d2a5c62169d2bff5d8ba2b7c151787f8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ScriptTagSettingTabContainer_DiscardModuleDraftMutation$variables = {
  siteId: string;
  moduleId: string;
};
export type ScriptTagSettingTabContainer_DiscardModuleDraftMutationVariables = ScriptTagSettingTabContainer_DiscardModuleDraftMutation$variables;
export type ScriptTagSettingTabContainer_DiscardModuleDraftMutation$data = {
  readonly discardUserTagModuleDraft: {
    readonly site: {
      readonly " $fragmentSpreads": FragmentRefs<"ScriptTagSettingTabContainer_site">;
    };
    readonly userTagModule: {
      readonly id: string;
      readonly draftContent: string | null;
      readonly draftEnabled: boolean | null;
      readonly hasDraft: boolean;
      readonly hasPendingToggle: boolean;
      readonly hasPendingChanges: boolean;
    };
  } | null;
};
export type ScriptTagSettingTabContainer_DiscardModuleDraftMutationResponse = ScriptTagSettingTabContainer_DiscardModuleDraftMutation$data;
export type ScriptTagSettingTabContainer_DiscardModuleDraftMutation = {
  variables: ScriptTagSettingTabContainer_DiscardModuleDraftMutationVariables;
  response: ScriptTagSettingTabContainer_DiscardModuleDraftMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "moduleId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "siteId"
},
v2 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "moduleId",
        "variableName": "moduleId"
      },
      {
        "kind": "Variable",
        "name": "siteId",
        "variableName": "siteId"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "draftContent",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "draftEnabled",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasDraft",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasPendingToggle",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasPendingChanges",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "UserTagModule",
  "kind": "LinkedField",
  "name": "userTagModule",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v4/*: any*/),
    (v5/*: any*/),
    (v6/*: any*/),
    (v7/*: any*/),
    (v8/*: any*/)
  ],
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "versionNumber",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tagContent",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "authorName",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publishedAt",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "enabled",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "priority",
  "storageKey": null
},
v20 = [
  (v3/*: any*/),
  (v17/*: any*/)
],
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v22 = [
  (v3/*: any*/),
  (v21/*: any*/)
],
v23 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 500
  }
],
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "Page",
  "kind": "LinkedField",
  "name": "page",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Funnel",
      "kind": "LinkedField",
      "name": "funnel",
      "plural": false,
      "selections": (v20/*: any*/),
      "storageKey": null
    },
    (v3/*: any*/)
  ],
  "storageKey": null
},
v25 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "moduleName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fromLabel",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "toLabel",
    "storageKey": null
  }
],
v26 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "codeDraftModuleNames",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "addedModuleNames",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "removedModuleNames",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "UserTagToggleChange",
    "kind": "LinkedField",
    "name": "toggleChanges",
    "plural": true,
    "selections": (v25/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "UserTagToggleChange",
    "kind": "LinkedField",
    "name": "linkChanges",
    "plural": true,
    "selections": (v25/*: any*/),
    "storageKey": null
  }
],
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "versionName",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ScriptTagSettingTabContainer_DiscardModuleDraftMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "DiscardUserTagModuleDraftPayload",
        "kind": "LinkedField",
        "name": "discardUserTagModuleDraft",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Site",
            "kind": "LinkedField",
            "name": "site",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ScriptTagSettingTabContainer_site"
              }
            ],
            "storageKey": null
          },
          (v9/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ScriptTagSettingTabContainer_DiscardModuleDraftMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "DiscardUserTagModuleDraftPayload",
        "kind": "LinkedField",
        "name": "discardUserTagModuleDraft",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Site",
            "kind": "LinkedField",
            "name": "site",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "embedTag",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "robeeTag",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "userTagDraft",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UserTagModule",
                "kind": "LinkedField",
                "name": "userTagPublishedModule",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UserTagModule",
                "kind": "LinkedField",
                "name": "userTagModules",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "effectiveEnabled",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isDistributionGated",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isDraftDistributionGated",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasPendingLinkChange",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isArchive",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "deletedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PopupGroup",
                    "kind": "LinkedField",
                    "name": "popupGroups",
                    "plural": true,
                    "selections": (v20/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AbtestScenarioPageGroup",
                    "kind": "LinkedField",
                    "name": "abtestScenarioPageGroups",
                    "plural": true,
                    "selections": (v22/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PopupGroup",
                    "kind": "LinkedField",
                    "name": "draftPopupGroups",
                    "plural": true,
                    "selections": (v20/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AbtestScenarioPageGroup",
                    "kind": "LinkedField",
                    "name": "draftAbtestScenarioPageGroups",
                    "plural": true,
                    "selections": (v22/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v23/*: any*/),
                "concreteType": "PopupGroupConnection",
                "kind": "LinkedField",
                "name": "popupGroups",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PopupGroupEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PopupGroup",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v17/*: any*/),
                          (v24/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "popupGroups(first:500)"
              },
              {
                "alias": null,
                "args": (v23/*: any*/),
                "concreteType": "AbtestScenarioPageGroupConnection",
                "kind": "LinkedField",
                "name": "abtestScenarioPageGroups",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AbtestScenarioPageGroupEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AbtestScenarioPageGroup",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v21/*: any*/),
                          (v24/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "abtestScenarioPageGroups(first:500)"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UserTagModule",
                "kind": "LinkedField",
                "name": "enabledUserTagModules",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v11/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "mergedTagPreview",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "draftMergedTagPreview",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "enabledModuleCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalModuleCount",
                "storageKey": null
              },
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasWorkspaceDeployDrift",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UserTagWorkspacePendingChangeSummary",
                "kind": "LinkedField",
                "name": "userTagWorkspacePendingChangeSummary",
                "plural": false,
                "selections": (v26/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UserTagVersion",
                "kind": "LinkedField",
                "name": "userTagVersions",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v27/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v28/*: any*/),
                  (v16/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "content",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserTagWorkspacePendingChangeSummary",
                    "kind": "LinkedField",
                    "name": "changeSummary",
                    "plural": false,
                    "selections": (v26/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserTagVersionModuleSnapshot",
                    "kind": "LinkedField",
                    "name": "modulesSnapshot",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "moduleId",
                        "storageKey": null
                      },
                      (v17/*: any*/),
                      (v18/*: any*/),
                      (v19/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "gated",
                        "storageKey": null
                      },
                      (v11/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UserTagVersion",
                "kind": "LinkedField",
                "name": "activeUserTagVersion",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v27/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v28/*: any*/),
                  (v16/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v9/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9ae753130556e90dcd4efd7d4f90afc6",
    "id": null,
    "metadata": {},
    "name": "ScriptTagSettingTabContainer_DiscardModuleDraftMutation",
    "operationKind": "mutation",
    "text": "mutation ScriptTagSettingTabContainer_DiscardModuleDraftMutation(\n  $siteId: ID!\n  $moduleId: ID!\n) {\n  discardUserTagModuleDraft(input: {siteId: $siteId, moduleId: $moduleId}) {\n    site {\n      ...ScriptTagSettingTabContainer_site\n      id\n    }\n    userTagModule {\n      id\n      draftContent\n      draftEnabled\n      hasDraft\n      hasPendingToggle\n      hasPendingChanges\n    }\n  }\n}\n\nfragment ScriptTagSettingTabContainer_site on Site {\n  id\n  embedTag\n  robeeTag\n  userTagDraft\n  userTagPublishedModule {\n    id\n    versionNumber\n    tagContent\n    status\n    description\n    authorName\n    publishedAt\n    createdAt\n  }\n  userTagModules {\n    id\n    versionNumber\n    tagContent\n    status\n    description\n    authorName\n    publishedAt\n    createdAt\n    name\n    enabled\n    priority\n    draftContent\n    draftEnabled\n    hasDraft\n    hasPendingToggle\n    hasPendingChanges\n    effectiveEnabled\n    isDistributionGated\n    isDraftDistributionGated\n    hasPendingLinkChange\n    isArchive\n    deletedAt\n    popupGroups {\n      id\n      name\n    }\n    abtestScenarioPageGroups {\n      id\n      title\n    }\n    draftPopupGroups {\n      id\n      name\n    }\n    draftAbtestScenarioPageGroups {\n      id\n      title\n    }\n  }\n  popupGroups(first: 500) {\n    edges {\n      node {\n        id\n        name\n        page {\n          funnel {\n            id\n            name\n          }\n          id\n        }\n      }\n    }\n  }\n  abtestScenarioPageGroups(first: 500) {\n    edges {\n      node {\n        id\n        title\n        page {\n          funnel {\n            id\n            name\n          }\n          id\n        }\n      }\n    }\n  }\n  enabledUserTagModules {\n    id\n    name\n    enabled\n    priority\n    tagContent\n  }\n  mergedTagPreview\n  draftMergedTagPreview\n  enabledModuleCount\n  totalModuleCount\n  hasPendingChanges\n  hasWorkspaceDeployDrift\n  userTagWorkspacePendingChangeSummary {\n    codeDraftModuleNames\n    addedModuleNames\n    removedModuleNames\n    toggleChanges {\n      moduleName\n      fromLabel\n      toLabel\n    }\n    linkChanges {\n      moduleName\n      fromLabel\n      toLabel\n    }\n  }\n  userTagVersions {\n    id\n    versionName\n    description\n    authorName\n    isActive\n    createdAt\n    content\n    changeSummary {\n      codeDraftModuleNames\n      addedModuleNames\n      removedModuleNames\n      toggleChanges {\n        moduleName\n        fromLabel\n        toLabel\n      }\n      linkChanges {\n        moduleName\n        fromLabel\n        toLabel\n      }\n    }\n    modulesSnapshot {\n      moduleId\n      name\n      enabled\n      priority\n      gated\n      tagContent\n    }\n  }\n  activeUserTagVersion {\n    id\n    versionName\n    description\n    authorName\n    isActive\n    createdAt\n  }\n}\n"
  }
};
})();

(node as any).hash = "94e5e7970bfdaae0a2ec42f708d657fa";

export default node;
